import React from 'react'
import BaseComponent, { errorMap } from './BaseComponent'
import Modal from './Modal'
import _ from 'lodash'
import ReactPaginate from 'react-paginate';
import JSONPretty from 'react-json-pretty';
import 'react-json-pretty/themes/monikai.css';
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css"
import { registerLocale } from "react-datepicker";
import pl from 'date-fns/locale/pl';
import Dropzone from 'react-dropzone';

registerLocale('pl', pl)

export default class ListPage extends BaseComponent {

  constructor(props) {
    super(props)
    this.state = { list: [], itemId: null, preloader: true, consumer: "", page: 0, pages: 0, category: "test", sortBy: "publicationDate", filters: {}, mapUUID: "", dateBefore: new Date(), dateAfter: new Date(), email: "", phone: "", type: "chic", transactionId:"", value:"", receiptValue:"",timestamp:"", limit: 20, offset: 0, 
      chicId: "",
      deviceModel: "",
      deviceColour: "",
      deviceSerial: "",
      receiptId: "",
      registerId: "",
      files: [],
      imageError: false
    }
    this._bind('closeConfirm', 'handlePageClick', 'sendFormData', 'onDrop')
  }

  onDrop(acceptedFiles, rejectedFiles) {
    if(acceptedFiles.length > 0) {
        this.setState({
            imageError: false,
            files: acceptedFiles.map(file => Object.assign(file, {
              preview: URL.createObjectURL(file)
            }))
        })
    } else if(rejectedFiles.length > 0) {
        console.log("rejectedFiles")
        this.setState({
            imageError: true
        })
    }
  }

  sendFormData() {
    let url = this.props.API + this.props.data.endpointList;

    let payloadObject = {
      consumer: {
        chicId: this.state.chicId
      },
      device: {
        model: this.state.deviceModel,
        colour: this.state.deviceColour,
        serialNumber: this.state.deviceSerial
      },
      receipt: {
        receiptId: this.state.receiptId,
        registerId: this.state.registerId,
        payload: []
      }
    };

    let formData = new FormData();
    formData.append('files[]', this.state.files[0], this.state.files[0]?.name);
    formData.append('_input', JSON.stringify(payloadObject));

    fetch(url, {
      method: "POST",
      headers: {
        "Authorization": "Bearer " + sessionStorage.getItem('token')
      },
      body: formData
    })
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      if (!result.status || !result.status.success) {
        window.dispatchEvent(new CustomEvent("NOTIFY", { 
          'detail': {
            'type': "red", 
            'content' : errorMap(result.data?.error?.ident || result.data?.error)
          }
        }), true);

        let res = result.data || [];

        this.setState({ 
          list: res, 
          preloader: false,
        });
      } else {
        // console.log(result)
        let res = result.data || [];
        if (res === null) {
          res = [];
        }
        const ordered = res;
        
        const totalLength = result.data?.total?.length || 0;
        this.setState({ pages: Math.ceil(totalLength / 20) });
        
        this.setState({ 
          list: ordered, 
          preloader: false, 
          pages: result.data ? result.data.pages : [] 
        });
        
        window.dispatchEvent(new CustomEvent("NOTIFY", { 
          'detail': {
            'type': "green", 
            'content' : "Register successful."
          }
        }), true);
      }
    }, (error) => {
      console.log(error);
    });
  }

  closeConfirm() {
    this.setState({ confirm: false, itemId: null })
  }

  handlePageClick(data) {
    this.setState({ page: data.selected, preloader: true }, () => {
      this.getData(this.state.mapUUID)
    })
  }

  render () {
    let filteredList = this.state.list

    let image = this.state.files.length > 0 ? this.state.files[0].preview : null

    return (
      <section className="list">
        <div className="container">
    			<h1>{ this.props.data.name }</h1>
          <div className='s-box'>
            <label>ChicId:</label>
            <div className="">
              <input type="text" placeholder="chicId" value={ this.state.chicId } onChange={ (e) => { this.setState({ chicId: e.target.value })} }/>
            </div>
            <label>Device model:</label>
            <div className="">
              <input type="text" placeholder="deviceModel" value={ this.state.deviceModel } onChange={ (e) => { this.setState({ deviceModel: e.target.value })} }/>
            </div>
            <label>Device colour:</label>
            <div className="">
              <input type="text" placeholder="deviceColour" value={ this.state.deviceColour } onChange={ (e) => { this.setState({ deviceColour: e.target.value })} }/>
            </div>
            <label>Device serial number:</label>
            <div className="">
              <input type="text" placeholder="deviceSerial" value={ this.state.deviceSerial } onChange={ (e) => { this.setState({ deviceSerial: e.target.value })} }/>
            </div>
            <label>Receipt Id:</label>
            <div className="">
              <input type="text" placeholder="receiptId" value={ this.state.receiptId } onChange={ (e) => { this.setState({ receiptId: e.target.value })} }/>
            </div>
            <label>Register Id:</label>
            <div className="">
              <input type="text" placeholder="registerId" value={ this.state.registerId } onChange={ (e) => { this.setState({ registerId: e.target.value })} }/>
            </div>
            <label>Receipt image:</label>
            <Dropzone maxSize={10000000} accept={["image/png","image/jpeg","image/svg+xml", "image/svg"]} className={ this.state.imageError ? "dropzone dropzone-reject" : "dropzone" } activeClassName="dropzone-active" rejectClassName="dropzone-reject" multiple={ false } onDrop={ this.onDrop }>
            {({getRootProps, getInputProps}) => (
                <div className={ this.state.imageError ? "dropzone dropzone-reject" : "dropzone" }>
                  <div {...getRootProps()}>
                    <input {...getInputProps()} />
                    { image ? <img src={ image } alt="" style={{ maxWidth: "100%", maxHeight: "100%" }}/> : <p>Drag'n'drop do add file</p> }
                  </div>
                </div>
              )}
            </Dropzone>
          </div>
          <div className='s-box'>
            <button onClick={this.sendFormData}>Register device</button>
          </div>
          <JSONPretty id="json-pretty" data={filteredList}></JSONPretty>
	  	  </div>
      </section>
    )
  }
}
